module.exports = __webpack_public_path__ + "static/media/level2.75184387.svg";